var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permission(283)&&_vm.title)?_c('el-button',{staticClass:"online-cashes-button-table",attrs:{"disabled":_vm.loading,"icon":_vm.icon,"title":_vm.title,"type":"primary"},on:{"click":_vm.click}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }